/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    EventCreateModel,
    EventModel,
    EventUpdateModel,
    HTTPValidationError,
    ListEventAdminResponse,
    ListEventResponse,
    ListEventsByDateResponse,
    ResponseGetEventApiV1EventsEventGet,
    Search,
} from '../models/index';
import {
    EventCreateModelFromJSON,
    EventCreateModelToJSON,
    EventModelFromJSON,
    EventModelToJSON,
    EventUpdateModelFromJSON,
    EventUpdateModelToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ListEventAdminResponseFromJSON,
    ListEventAdminResponseToJSON,
    ListEventResponseFromJSON,
    ListEventResponseToJSON,
    ListEventsByDateResponseFromJSON,
    ListEventsByDateResponseToJSON,
    ResponseGetEventApiV1EventsEventGetFromJSON,
    ResponseGetEventApiV1EventsEventGetToJSON,
    SearchFromJSON,
    SearchToJSON,
} from '../models/index';

export interface CreateEventApiV1EventsEventPostRequest {
    eventCreateModel: EventCreateModel;
}

export interface DeleteEventApiV1EventsEventDeleteRequest {
    id: string;
}

export interface EventUpdateApiV1EventsEventPutRequest {
    id: string;
    eventUpdateModel: EventUpdateModel;
}

export interface GetEventAdminApiV1EventsAdminEventGetRequest {
    id: string;
}

export interface GetEventApiV1EventsEventGetRequest {
    id: string;
}

export interface GetEventsAdminApiV1EventsAdminGetRequest {
    limit?: number;
    offset?: number;
}

export interface GetEventsApiV1EventsGetRequest {
    search?: Search;
    limit?: number;
    offset?: number;
}

export interface GetEventsByDateApiV1EventsEventDateGetRequest {
    date: Date;
}

/**
 *
 */
export class EventApi extends runtime.BaseAPI {
    /**
     * Create a new event.
     * Create Event
     */
    async createEventApiV1EventsEventPostRaw(
        requestParameters: CreateEventApiV1EventsEventPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<EventModel>> {
        if (requestParameters['eventCreateModel'] == null) {
            throw new runtime.RequiredError(
                'eventCreateModel',
                'Required parameter "eventCreateModel" was null or undefined when calling createEventApiV1EventsEventPost().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/events/event`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: EventCreateModelToJSON(requestParameters['eventCreateModel']),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => EventModelFromJSON(jsonValue));
    }

    /**
     * Create a new event.
     * Create Event
     */
    async createEventApiV1EventsEventPost(
        requestParameters: CreateEventApiV1EventsEventPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<EventModel> {
        const response = await this.createEventApiV1EventsEventPostRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete an event by its ID.
     * Delete Event
     */
    async deleteEventApiV1EventsEventDeleteRaw(
        requestParameters: DeleteEventApiV1EventsEventDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteEventApiV1EventsEventDelete().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/events/event`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete an event by its ID.
     * Delete Event
     */
    async deleteEventApiV1EventsEventDelete(
        requestParameters: DeleteEventApiV1EventsEventDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<any> {
        const response = await this.deleteEventApiV1EventsEventDeleteRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update an event with the given information.
     * Event Update
     */
    async eventUpdateApiV1EventsEventPutRaw(
        requestParameters: EventUpdateApiV1EventsEventPutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<EventModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling eventUpdateApiV1EventsEventPut().',
            );
        }

        if (requestParameters['eventUpdateModel'] == null) {
            throw new runtime.RequiredError(
                'eventUpdateModel',
                'Required parameter "eventUpdateModel" was null or undefined when calling eventUpdateApiV1EventsEventPut().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/events/event`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: EventUpdateModelToJSON(requestParameters['eventUpdateModel']),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => EventModelFromJSON(jsonValue));
    }

    /**
     * Update an event with the given information.
     * Event Update
     */
    async eventUpdateApiV1EventsEventPut(
        requestParameters: EventUpdateApiV1EventsEventPutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<EventModel> {
        const response = await this.eventUpdateApiV1EventsEventPutRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve an event by its ID for the admin view.
     * Get Event Admin
     */
    async getEventAdminApiV1EventsAdminEventGetRaw(
        requestParameters: GetEventAdminApiV1EventsAdminEventGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<EventModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getEventAdminApiV1EventsAdminEventGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/events/admin/event`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => EventModelFromJSON(jsonValue));
    }

    /**
     * Retrieve an event by its ID for the admin view.
     * Get Event Admin
     */
    async getEventAdminApiV1EventsAdminEventGet(
        requestParameters: GetEventAdminApiV1EventsAdminEventGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<EventModel> {
        const response = await this.getEventAdminApiV1EventsAdminEventGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve an event by its ID.
     * Get Event
     */
    async getEventApiV1EventsEventGetRaw(
        requestParameters: GetEventApiV1EventsEventGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ResponseGetEventApiV1EventsEventGet>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getEventApiV1EventsEventGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/events/event`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ResponseGetEventApiV1EventsEventGetFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve an event by its ID.
     * Get Event
     */
    async getEventApiV1EventsEventGet(
        requestParameters: GetEventApiV1EventsEventGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ResponseGetEventApiV1EventsEventGet> {
        const response = await this.getEventApiV1EventsEventGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve events for the admin view.
     * Get Events Admin
     */
    async getEventsAdminApiV1EventsAdminGetRaw(
        requestParameters: GetEventsAdminApiV1EventsAdminGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ListEventAdminResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/events/admin`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ListEventAdminResponseFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve events for the admin view.
     * Get Events Admin
     */
    async getEventsAdminApiV1EventsAdminGet(
        requestParameters: GetEventsAdminApiV1EventsAdminGetRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ListEventAdminResponse> {
        const response = await this.getEventsAdminApiV1EventsAdminGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve events based on the provided search criteria.
     * Get Events
     */
    async getEventsApiV1EventsGetRaw(
        requestParameters: GetEventsApiV1EventsGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ListEventResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/events/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ListEventResponseFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve events based on the provided search criteria.
     * Get Events
     */
    async getEventsApiV1EventsGet(
        requestParameters: GetEventsApiV1EventsGetRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ListEventResponse> {
        const response = await this.getEventsApiV1EventsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve events by date.
     * Get Events By Date
     */
    async getEventsByDateApiV1EventsEventDateGetRaw(
        requestParameters: GetEventsByDateApiV1EventsEventDateGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ListEventsByDateResponse>> {
        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling getEventsByDateApiV1EventsEventDateGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = (requestParameters['date'] as any)
                .toISOString()
                .substring(0, 10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/events/event/date`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ListEventsByDateResponseFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve events by date.
     * Get Events By Date
     */
    async getEventsByDateApiV1EventsEventDateGet(
        requestParameters: GetEventsByDateApiV1EventsEventDateGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ListEventsByDateResponse> {
        const response = await this.getEventsByDateApiV1EventsEventDateGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
